import React from 'react';
import { useTranslation } from '../context/TranslationContext';
import { T } from './Typo';

const COPY = {
  es: {
    title: 'Preguntas',
    more: '¿Otra duda? Escríbenos a',
    faqs: [
      ['¿Cuánto cuesta un proyecto?', [
        'No tenemos precio de partida: una web de cinco páginas y una plataforma con cobros no se parecen en nada.',
        'Después del diagnóstico, que es gratis, recibes un presupuesto cerrado y por escrito de la primera fase.',
      ]],
      ['¿De quién es el código?', [
        'Tuyo. Tienes acceso al repositorio desde el primer día y, si decides seguir con otro equipo, te lo entregamos documentado.',
      ]],
      ['¿Dónde quedan mis datos?', [
        'Pueden quedarse en tus servidores. Con datos sensibles, el modelo de IA también puede funcionar en local, sin que la información salga de tu red.',
      ]],
      ['¿Qué modelos de IA se usan?', [
        'Depende del caso: modelos de OpenAI o de Anthropic, o modelos abiertos cuando los datos no deben salir de casa.',
      ]],
      ['¿Necesito saber de tecnología?', [
        'No. Basta con que nos enseñes cómo se hace hoy el trabajo, con el Excel o los correos delante. La parte técnica la llevamos nosotros.',
      ]],
      ['¿Y si mi empresa no está en España?', [
        'También trabajamos en remoto con empresas de Latinoamérica. Las reuniones son por videollamada y las entregas siguen llegando cada dos semanas.',
      ]],
    ],
  },
  en: {
    title: 'Questions',
    more: 'Another question? Write to',
    faqs: [
      ['How much does it cost?', [
        "It depends on scope. We've done everything from integrations that took a few days to platforms that took several months.",
        "After the diagnosis we give you a fixed price for the first phase, so you know what you'll pay before you sign anything.",
      ]],
      ['Who owns the code?', [
        'You have access to the code and documentation from day one, in a repository you can open whenever you like. If you ever want to continue with another team, you can.',
      ]],
      ['Where does our data live?', [
        'Wherever it needs to: your cloud, a private cloud or your own servers. Data is encrypted and every access is logged.',
        "With sensitive data, the AI model can also run locally, without the information leaving your network.",
      ]],
      ['Which AI models do you use?', [
        'Whatever fits the case and your privacy rules: sometimes a commercial model from OpenAI or Anthropic, sometimes an open model running on your servers. Quite a few projects have no AI in them.',
      ]],
      ['Do we need to know about AI or programming?', [
        "No. You just need to be able to explain what you do today and what bothers you. If your data lives in spreadsheets or an old program, that's enough to start.",
      ]],
      ['Do you work outside Spain?', [
        'Yes, with clients in Latin America too, remotely.',
      ]],
    ],
  },
};

export default function FAQ() {
  const { lang } = useTranslation();
  const c = COPY[lang] || COPY.es;

  return (
    <section id="faq" className="section" aria-labelledby="faq-title">
      <div className="wrap faq-grid">
        <div className="faq-side">
          <h2 id="faq-title" className="t-1">{c.title}</h2>
          <p className="t-lead">{c.more} <a className="link" href="mailto:contact@qyntix.com">contact@qyntix.com</a></p>
        </div>
        <div className="faq">
          {c.faqs.map(([q, paras]) => (
            <details key={q}>
              <summary><span><T>{q}</T></span></summary>
              <div className="answer">{paras.map((p) => <p key={p}><T>{p}</T></p>)}</div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
